import React from 'react';
import { Banner, Text, TimeWithTimeZone } from '@common/components';

export const ComplianceDeadlineInfoBanner = ({
  deadlineDetails,
  deadlineDueDate,
}: {
  deadlineDetails?: string;
  deadlineDueDate?: string;
}) => {
  if (!deadlineDetails && !deadlineDueDate) {
    return null;
  }

  return (
    <Banner
      closable
      type="info"
      content={
        <>
          Due:{' '}
          {deadlineDueDate && (
            <>
              <Text weight="bold">
                <TimeWithTimeZone date={deadlineDueDate} />
              </Text>
              .{' '}
            </>
          )}
          {deadlineDetails}
        </>
      }
    />
  );
};
